export function formatAddress(address) {
  if (!address) return '-';

  const parts = [];
  if (address.Street) parts.push(address.Street);
  if (address.City) parts.push(address.City);
  if (address.State) parts.push(address.State);
  if (address.ZipCode) parts.push(address.ZipCode);

  return parts.length > 0 ? parts.join(', ') : '-';
}
